module.exports = new __parcel__URL__("medical_academy_level_1.cee02db3.png").toString();